import type { PatientJourneySummaryKind } from "@rmh/defs";

export const PATIENT_JOURNEY_QUERY_KEY = "patientJourney";

export const patientJourneyFactsQueryKey = (input: string) =>
  [PATIENT_JOURNEY_QUERY_KEY, "facts", input] as const;

export const patientJourneyVerdictQueryKey = (input: string) =>
  [PATIENT_JOURNEY_QUERY_KEY, "verdict", input] as const;

export const patientJourneySummaryQueryKey = (
  kind: PatientJourneySummaryKind | null,
  ref: string | null
) => [PATIENT_JOURNEY_QUERY_KEY, "summary", kind, ref] as const;
